export async function getTaxRate(zipcode) {
    let url = ('https://test-tf-data-jalvarado91.vercel.app/api/salesTax?zipcode=' + zipcode);
    const response = await fetch(url);
    const responseData = await response.json();
    return responseData;
}

export function calculateSalesTax(
    sales: number,
    rate: number
) {
    var finalNumber = (sales * rate) / 100;
    if (isNaN(finalNumber)) {
        return 'n/a';
    } else {
        return finalNumber
    }
}